import { IPreviewAudit, } from 'atlas-shared';

export const auditPageLink = (id: IPreviewAudit['id'], pk: IPreviewAudit['pk']) => `/admin/audit/page/?id=${id}&pk=${pk}`;
export const auditSearchLink = (table: string | Array<string>, pk: number) => `/admin/audits/search?ff={"pk":["${pk}"],"table":${JSON.stringify(Array.isArray(table) ? table : [table, ])}}`;
